import usePut from '../../../core/composables/api/usePut'
import { ApiRequestStatus } from '../../../core/models/api/api-request-status'
import { useSnackStore } from '../../../stores/snack.store'
import { CoachingStatus } from '../../dashboard/composables/useCoachingInvitations'
import useDelete from '../../../core/composables/api/useDelete'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import { useUserStore } from '../../../stores/user.store'
import usePost from '../../../core/composables/api/usePost'

export const useMutateCoachee = () => {
  const snackStore = useSnackStore()
  const { user } = useUserStore()
  const coachingInvitationUpdatedBus = useEventBus(EventKey.coachingInvitationUpdated)
  const coachingAddedBus = useEventBus(EventKey.coachingAdded)

  const { mutate, status: updateCoachingStatus } = usePut<
    void,
    {
      coachId: string
      coacheeId: string
      status: CoachingStatus
    }
  >('coaching/invitation')

  const resendCoachingInvitation = async (coacheeId: string) => {
    await mutate({ coachId: user.id, coacheeId: coacheeId, status: CoachingStatus.Pending })

    if (updateCoachingStatus.value == ApiRequestStatus.Success) {
      coachingInvitationUpdatedBus.emit({ coacheeId: coacheeId })
      snackStore.showInfo('Coaching Einladung erneut gesendet.')
    } else {
      snackStore.showError('Coaching einladung konnte nicht gesendet werden!')
    }
  }

  const coachingDeletedBus = useEventBus(EventKey.coachingDeleted)

  const deleteCoaching = async (coacheeId: string) => {
    const { remove, status: deleteCoachingStatus } = useDelete(`coaching/${coacheeId}`)

    await remove({})

    if (deleteCoachingStatus.value == ApiRequestStatus.Success) {
      coachingDeletedBus.emit({ coacheeId: coacheeId })
      snackStore.showInfo('Coaching wurde beendet.')
    } else {
      snackStore.showError('Ein Fehler ist aufgetreten.')
    }
  }

  const addCoachee = async (coacheeId: string) => {
    const { mutate, status: addCoachingStatus } = usePost<void, { coacheeId: string }>(
      'coaching/coachee',
    )

    await mutate({ coacheeId: coacheeId })

    if (addCoachingStatus.value == ApiRequestStatus.Success) {
      coachingAddedBus.emit({ coacheeId: coacheeId })
      snackStore.showInfo('Coaching wurde hinzugefügt.')
    } else {
      snackStore.showError('Ein Fehler ist aufgetreten.')
    }
  }

  return {
    resendCoachingInvitation,
    updateCoachingStatus,
    deleteCoaching,
    addCoachee,
  }
}
